import { gql } from "@apollo/client";

export const RESEND_ACTIVATION = gql`
  mutation resendActivationLink($email: String!) {
    resendActivationLink(emailAddress: $email)
  }
`;
